function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as leb from 'leb128';
import { blake2b } from 'blakejs';
import * as uint8arrays from 'uint8arrays';
import { utils } from 'ethers';
import { base32 as base32Function } from './base32';
import { DelegatedNamespace, Protocol } from './enums';
import { CoinType } from './coinType';
export * from './coinType';
export * from './enums';

function getLeb128Length(input) {
  var _iterator = _createForOfIteratorHelper(input.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          index = _step$value[0],
          byte = _step$value[1];

      if (byte < 128) return index + 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  throw new Error('Failed to get Leb128 length');
}

var defaultCoinType = CoinType.MAIN;
var base32 = base32Function('abcdefghijklmnopqrstuvwxyz234567'); // Store valid CoinTypes / Protocols for runtime validation

var coinTypes = Object.values(CoinType);
var protocols = Object.values(Protocol).filter(function (p) {
  return typeof p === 'number';
}); // Defines the hash length taken over addresses
// using the Actor and SECP256K1 protocols.

var payloadHashLength = 20; // The length of a BLS public key

var blsPublicKeyBytes = 48; // The maximum length of a delegated address's sub-address.

var maxSubaddressLen = 54; // The maximum length of `int64` as a string.

var maxInt64StringLength = 19; // The hash length used for calculating address checksums.

var checksumHashLength = 4; // The length of an Ethereum address in bytes

var ethAddressLength = 20;

function addressHash(ingest) {
  return blake2b(ingest, null, payloadHashLength);
}

export var Address = /*#__PURE__*/function () {
  function Address(bytes) {
    var coinType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCoinType;

    _classCallCheck(this, Address);

    _defineProperty(this, "bytes", void 0);

    _defineProperty(this, "_coinType", void 0);

    if (!bytes || !bytes.length) throw new Error('Missing bytes in address');
    this.bytes = bytes;
    this._coinType = coinType;

    if (!(this.protocol() in Protocol)) {
      throw new Error("Invalid protocol ".concat(this.protocol()));
    }
  }

  _createClass(Address, [{
    key: "network",
    value: function network() {
      return this._coinType;
    }
  }, {
    key: "coinType",
    value: function coinType() {
      return this._coinType;
    }
  }, {
    key: "protocol",
    value: function protocol() {
      return this.bytes[0];
    }
  }, {
    key: "payload",
    value: function payload() {
      return this.bytes.slice(1);
    }
  }, {
    key: "toString",

    /**
     * toString returns a string representation of this address. If no "coinType"
     * parameter was passed to the constructor the address will be prefixed with
     * the default coinType prefix "f" (mainnet).
     */
    value: function toString() {
      return encode(this._coinType, this);
    }
    /**
     * equals determines if this address is the "same" address as the passed
     * address. Two addresses are considered equal if they are the same instance
     * OR if their "bytes" property matches byte for byte.
     */

  }, {
    key: "equals",
    value: function equals(addr) {
      if (this === addr) {
        return true;
      }

      return uint8arrays.equals(this.bytes, addr.bytes);
    }
  }, {
    key: "namespaceLength",
    get: function get() {
      if (this.protocol() !== Protocol.DELEGATED) throw new Error('Can only get namespace length for delegated addresses');
      return getLeb128Length(this.payload());
    }
  }, {
    key: "namespace",
    get: function get() {
      if (this.protocol() !== Protocol.DELEGATED) throw new Error('Can only get namespace for delegated addresses');
      var namespaceBytes = this.payload().slice(0, this.namespaceLength);
      return Number(leb.unsigned.decode(namespaceBytes));
    }
  }, {
    key: "subAddr",
    get: function get() {
      if (this.protocol() !== Protocol.DELEGATED) throw new Error('Can only get subaddress for delegated addresses');
      return this.bytes.slice(this.namespaceLength + 1);
    }
  }, {
    key: "subAddrHex",
    get: function get() {
      return uint8arrays.toString(this.subAddr, 'hex');
    }
  }]);

  return Address;
}();
export function bigintToArray(v) {
  var tmp = BigInt(v).toString(16);
  if (tmp.length % 2 === 1) tmp = "0".concat(tmp);
  return uint8arrays.fromString(tmp, 'base16');
}
export function getChecksum(ingest) {
  return blake2b(ingest, null, checksumHashLength);
}
export function validateChecksum(data, checksum) {
  return uint8arrays.equals(getChecksum(data), checksum);
}
export function newAddress(protocol, payload, coinType) {
  var protocolByte = leb.unsigned.encode(protocol);
  return new Address(uint8arrays.concat([protocolByte, payload]), coinType);
}
export function newIDAddress(id, coinType) {
  return newAddress(Protocol.ID, leb.unsigned.encode(id), coinType);
}
/**
 * newActorAddress returns an address using the Actor protocol.
 */

export function newActorAddress(data, coinType) {
  return newAddress(Protocol.ACTOR, addressHash(data), coinType);
}
/**
 * newSecp256k1Address returns an address using the SECP256K1 protocol.
 */

export function newSecp256k1Address(pubkey, coinType) {
  return newAddress(Protocol.SECP256K1, addressHash(pubkey), coinType);
}
/**
 * newBLSAddress returns an address using the BLS protocol.
 */

export function newBLSAddress(pubkey, coinType) {
  return newAddress(Protocol.BLS, pubkey, coinType);
}
/**
 * newDelegatedAddress returns an address using the Delegated protocol.
 */

export function newDelegatedAddress(namespace, subAddr, coinType) {
  if (subAddr.length > maxSubaddressLen) throw new Error('Subaddress address length');
  var namespaceByte = leb.unsigned.encode(namespace);
  return newAddress(Protocol.DELEGATED, uint8arrays.concat([namespaceByte, subAddr]), coinType);
}
/**
 * newDelegatedEthAddress returns an address for eth using the Delegated protocol.
 */

export function newDelegatedEthAddress(ethAddr, coinType) {
  if (!utils.isAddress(ethAddr)) throw new Error('Invalid Ethereum address');
  return newDelegatedAddress(DelegatedNamespace.EVM, utils.arrayify(ethAddr), coinType);
}
export function decode(address) {
  var _checkAddressString = checkAddressString(address),
      protocol = _checkAddressString.protocol,
      payload = _checkAddressString.payload,
      coinType = _checkAddressString.coinType;

  return newAddress(protocol, payload, coinType);
}
export function encode(coinType, address) {
  if (!address || !address.bytes) throw Error('Invalid address');
  var protocol = address.protocol();
  var payload = address.payload();
  var prefix = "".concat(coinType).concat(protocol);

  switch (protocol) {
    case Protocol.ID:
      {
        return "".concat(prefix).concat(leb.unsigned.decode(payload));
      }

    case Protocol.DELEGATED:
      {
        var namespace = address.namespace;
        var subAddrBytes = address.subAddr;
        var protocolByte = leb.unsigned.encode(protocol);
        var namespaceByte = leb.unsigned.encode(namespace);
        var checksumBytes = getChecksum(uint8arrays.concat([protocolByte, namespaceByte, subAddrBytes]));
        var bytes = uint8arrays.concat([subAddrBytes, checksumBytes]);
        return "".concat(prefix).concat(namespace, "f").concat(base32.encode(bytes));
      }

    default:
      {
        var checksum = getChecksum(address.bytes);

        var _bytes = uint8arrays.concat([payload, checksum]);

        return "".concat(prefix).concat(base32.encode(_bytes));
      }
  }
}
export function newFromString(address) {
  return decode(address);
}
export function validateAddressString(addressString) {
  try {
    checkAddressString(addressString);
    return true;
  } catch (error) {
    return false;
  }
}
export function checkAddressString(address) {
  if (typeof address !== 'string' || address.length < 3) throw Error('Address should be a string of at least 3 characters');
  var coinType = address[0];
  if (!coinTypes.includes(coinType)) throw Error("Address cointype should be one of: ".concat(coinTypes.join(', ')));
  var protocol = Number(address[1]);
  if (!protocols.includes(protocol)) throw Error("Address protocol should be one of: ".concat(protocols.join(', ')));
  var protocolByte = leb.unsigned.encode(protocol);
  var raw = address.slice(2);

  switch (protocol) {
    case Protocol.ID:
      {
        if (raw.length > maxInt64StringLength) throw Error('Invalid ID address length');
        if (isNaN(Number(raw))) throw Error('Invalid ID address');
        var payload = leb.unsigned.encode(raw);
        var bytes = uint8arrays.concat([protocolByte, payload]);
        return {
          protocol: protocol,
          payload: payload,
          bytes: bytes,
          coinType: coinType
        };
      }

    case Protocol.DELEGATED:
      {
        var splitIndex = raw.indexOf('f');
        if (splitIndex === -1) throw new Error('Invalid delegated address');
        var namespaceStr = raw.slice(0, splitIndex);
        if (namespaceStr.length > maxInt64StringLength) throw new Error('Invalid delegated address namespace');
        var subAddrCksmStr = raw.slice(splitIndex + 1);
        var subAddrCksmBytes = base32.decode(subAddrCksmStr);
        if (subAddrCksmBytes.length < checksumHashLength) throw Error('Invalid delegated address length');
        var subAddrBytes = subAddrCksmBytes.slice(0, -checksumHashLength);
        var checksumBytes = subAddrCksmBytes.slice(subAddrBytes.length);
        if (subAddrBytes.length > maxSubaddressLen) throw Error('Invalid delegated address length');
        var namespaceNumber = Number(namespaceStr);
        var namespaceByte = leb.unsigned.encode(namespaceNumber);

        var _payload = uint8arrays.concat([namespaceByte, subAddrBytes]);

        var _bytes2 = uint8arrays.concat([protocolByte, _payload]);

        if (!validateChecksum(_bytes2, checksumBytes)) throw Error('Invalid delegated address checksum');
        return {
          protocol: protocol,
          payload: _payload,
          bytes: _bytes2,
          coinType: coinType,
          namespace: namespaceNumber
        };
      }

    case Protocol.SECP256K1:
    case Protocol.ACTOR:
    case Protocol.BLS:
      {
        var payloadCksm = base32.decode(raw);
        if (payloadCksm.length < checksumHashLength) throw Error('Invalid address length');

        var _payload2 = payloadCksm.slice(0, -checksumHashLength);

        var checksum = payloadCksm.slice(_payload2.length);
        if (protocol === Protocol.SECP256K1 || protocol === Protocol.ACTOR) if (_payload2.length !== payloadHashLength) throw Error('Invalid address length');
        if (protocol === Protocol.BLS) if (_payload2.length !== blsPublicKeyBytes) throw Error('Invalid address length');

        var _bytes3 = uint8arrays.concat([protocolByte, _payload2]);

        if (!validateChecksum(_bytes3, checksum)) throw Error('Invalid address checksum');
        return {
          protocol: protocol,
          payload: _payload2,
          bytes: _bytes3,
          coinType: coinType
        };
      }

    default:
      throw Error("Invalid address protocall: ".concat(protocol));
  }
}
/**
 * idFromAddress extracts the ID from an ID address.
 */

export function idFromAddress(address) {
  if (address.protocol() !== Protocol.ID) throw new Error('Cannot get ID from non ID address'); // An unsigned varint should be less than 2^63 which is < Number.MAX_VALUE.
  // So this number SHOULD be representable in JS and safe to parseInt.
  // https://github.com/multiformats/unsigned-varint
  // TODO: does leb128 enforce the max value?

  return parseInt(leb.unsigned.decode(address.payload()), 10);
}
/**
 * delegatedFromEthAddress derives the f410 address from an ethereum hex address
 */

export function delegatedFromEthAddress(ethAddr) {
  var coinType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CoinType.TEST;
  return newDelegatedEthAddress(ethAddr, coinType).toString();
}
/**
 * ethAddressFromDelegated derives the ethereum address from an f410 address
 */

export function ethAddressFromDelegated(delegated) {
  return utils.getAddress("0x".concat(decode(delegated).subAddrHex));
}
/**
 * ethAddressFromID derives the ethereum address from an f0 address
 */

export function ethAddressFromID(idAddress) {
  var address = decode(idAddress);
  var id = idFromAddress(address);
  var buffer = new ArrayBuffer(ethAddressLength);
  var dataview = new DataView(buffer);
  dataview.setUint8(0, 255);
  dataview.setBigUint64(12, BigInt(id), false);
  return "0x".concat(uint8arrays.toString(new Uint8Array(buffer), 'hex'));
}
export default {
  Address: Address,
  newAddress: newAddress,
  newIDAddress: newIDAddress,
  newActorAddress: newActorAddress,
  newSecp256k1Address: newSecp256k1Address,
  newBLSAddress: newBLSAddress,
  newFromString: newFromString,
  bigintToArray: bigintToArray,
  decode: decode,
  encode: encode,
  getChecksum: getChecksum,
  validateChecksum: validateChecksum,
  validateAddressString: validateAddressString,
  checkAddressString: checkAddressString,
  idFromAddress: idFromAddress,
  delegatedFromEthAddress: delegatedFromEthAddress,
  ethAddressFromDelegated: ethAddressFromDelegated,
  CoinType: CoinType,
  Protocol: Protocol
};
//# sourceMappingURL=index.js.map